import React, { Component } from 'react';
import { connect } from 'react-redux';
import HowMembershipWorksNegOp from './HowMembershipWorksNegOp.jsx';

class HowMembershipWorks extends Component {
    render() {
    		if(this.props.type === "Negative Option") return <HowMembershipWorksNegOp />;
        var second_check;

        if(this.props.tla == "MYG"){
            second_check = (<li>Discover the best new crime fiction each month</li>);
        }else if(this.props.tla == "LGA"){
            second_check = (<li>Discover the best new fiction, nonfiction, biographies, and more</li>);
        } else if(this.props.tla =="SFC"){
            second_check = (<li>Discover the best new science fiction, fantasy, horror, graphic novels and beyond.</li>);
        } else if(this.props.tla =="CRS"){
            second_check = (<li>Discover today's top Christian books, including uplifting fiction, meaningful nonfiction, and more.</li>);
        }

        var shutdown_period = false;
        if (['CRS','SFC','HBC'].includes(this.props.tla)) {
            shutdown_period = true;
        }

        let bookPrice = !this.props.bundle_pricing ? (<li>Hardcovers as low as ${this.props.second_book}</li>) : (<li>Hardcovers as low as ${this.props.second_book} when you bundle and save</li>);
        return(
            <div className="how-membership-works">
                <div className="benefits">
                    <h4 className="alt primary-color">Benefits of Your Membership</h4>
                    <div className="">
                        <div className="half-col check-list">
                            <ul>
                                {bookPrice}
                                {second_check}
                                <li>Always free shipping on 3 or more books*</li>
                                <li>No obligation, and you can cancel any time</li>
                                {shutdown_period ? '': <li>Skip your Member Credits any month</li> }
                            </ul>
                        </div>
                        <div className="half-col books">
                        </div>
                    </div>
                </div>

                <h4 className="alt primary-color">How Your Membership Works</h4>
                <div className="hiw">
                    { 
                        shutdown_period ?
                        <div>
                            <h3 id="Shutdown Notice">Cancel anytime.</h3>
                            <p>
                                After <b>{this.props.tla == 'CRS' ? '10/1/2025' : this.props.tla == 'SFC' ? '2/1/2025' : this.props.tla == 'HBC' ? '6/1/2025' : ''}</b>, orders will no longer be processed at {this.props.name}.
                            </p>
                            <p>
                                You can still redeem your existing credits on the site as normal until {this.props.tla == 'CRS' ? '10/1/2025' : this.props.tla == 'SFC' ? '2/1/2025' : this.props.tla == 'HBC' ? '6/1/2025' : ''}.
                            </p>
                            <p>
                                You can also still purchase books using a credit card on the site as normal until {this.props.tla == 'CRS' ? '10/1/2025' : this.props.tla == 'SFC' ? '2/1/2025' : this.props.tla == 'HBC' ? '6/1/2025' : ''}.
                            </p>
                            <p>
                                Beginning this month ({this.props.tla == 'CRS' ? 'October 2024' : this.props.tla == 'SFC' ? 'November 2024' : this.props.tla == 'HBC' ? 'February 2025' : ''}), you will no longer need to "SKIP" Member Credits, and you will no longer be automaticially charged for credits.
                                You will no longer be able to "SAVE" Member Credits at the beginning of each month.
                            </p>
                            <p>
                                If you have any questions, you can call us at {this.props.member_services_phone}.
                            </p>
                        </div>
                        :
                        <div>
                            <h3 id="member-credits">Save with Member Credits.</h3>
                            <p>
                            On the first of each month 2 Member Credits are available to purchase for ${this.props.one_credit} each.
                            <br/>
                            A Member Credit can be redeemed to purchase most books on the site.
                            </p>
                            <h3 id="skip-month">Skip any month.</h3>
                            <p>
                                If you don't want your monthly Member Credits, visit the site and click "SKIP" by the 10th of the month.
                                <br/>
                                If you don't click "SKIP", we will automatically purchase your credits for you using your credit card on file.
                            </p>
                            <h3 id="cancel-anytime">Cancel anytime.</h3>
                            <p>
                                There is no obligation to buy and you can cancel your membership anytime online or by calling {this.props.member_services_phone}.
                            </p>
                        </div>

                    }
                </div>

            </div>
        );
    }
}

function mapStateToProps(state){
    return {
      'name': state.store.name,
      'type': state.store.type,
      'one_credit': state.store.one_credit,
      'bundle_pricing': state.store.bundle_pricing,
      'second_book': state.store.second_book,
      'member_services_phone': state.store.member_services_phone,
      'regular_book_price': state.store.regular_book_price,
      'tla': state.store.tla
    };
}

export default connect(mapStateToProps)(HowMembershipWorks);



// WEBPACK FOOTER //
// ./src/components/HowMembershipWorks.jsx